import LipSyncPreviewImg from '@/shared/assets/images/lip-sync-preview.jpg';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const LIP_SYNC_DEMO_VIDEO_SRC = 'https://static.rask.ai/MLlips.mp4';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Lip-sync feature',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreatorPro,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  features: getBullets([
    'translate100',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
  ]),
  media: {
    poster: LipSyncPreviewImg,
    src: LIP_SYNC_DEMO_VIDEO_SRC,
    type: 'video',
    videoOptions: {
      autoPlay: true,
      controls: true,
      loop: true,
    },
  },
  mixpanelButtonClickEvent: MixpanelEvents.lipsyncUpgradeChoosePlanModalClick,
  mixpanelOpeningEvent: MixpanelEvents.lipsyncUpgradeModalShown,
  subtitle: 'Upgrade to Creator Pro plan to add lip-sync to your videos and experience top-notch translation quality',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
};

const STARTER_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
};

const CREATOR_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreator,
};

export const LIP_SYNC_CONTENT: LimitedFeatureContent = {
  creator: CREATOR_PLAN_CONTENT,
  starter: STARTER_PLAN_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
